import ApiUtils from './ApiUtils';

export default class AddressUtils {

  public static getRegions(countryCode: string = 'US'): string[] {
    const allRegions: any = this.countryRegionData.filter((obj) => obj.countryShortCode === countryCode);
    if (allRegions.length === 0) {
      return [];
    }
    const regions: any = allRegions[0].regions;
    const options: any = [];
    for (const region of regions) {
        options.push({value: region.shortCode, text: region.name});
    }
    return options;
  }

  public static getCountries(): any[] {
    const options: any = [];
    for (const country of this.countryRegionData) {
      options.push({value: country.countryShortCode, text: country.countryName});
    }
    return options;
  }

  public static toString(street, street2, city, state, zip, country): string {
    let data: string = ApiUtils.toString(street);
    data += (ApiUtils.hasValue(street2)) ? ', ' + ApiUtils.toString(street2) : '';
    data += (ApiUtils.hasValue(city)) ? ', ' + ApiUtils.toString(city) : '';
    data += (ApiUtils.hasValue(state)) ? ', ' + ApiUtils.toString(state) : '';
    data += (ApiUtils.hasValue(zip)) ? ' ' + ApiUtils.toString(zip) : '';
    data += (ApiUtils.hasValue(country)) ? ' ' + ApiUtils.toString(country) : '';
    return data;
  }

  private static countryRegionData = require('country-region-data');

}
